

import React from 'react';
import { Grid, Icon, Card } from 'semantic-ui-react';


const HelpTile = (props) => {
return (
        <Card
            style={styles.card}
            href={props.href}
            onClick={props.onTap}
            fluid
            raised >
                <Grid columns={2} >
                <Grid.Column textAlign="center" width="2">
                            <Icon  name={props.icon} size='huge' style={styles.icon}/>
                            </Grid.Column>
                            <Grid.Column width="14" >
            <Card.Header  as="h2">
                {props.title}
            </Card.Header>
            <Card.Meta>
{
    props.description
}        </Card.Meta>
        </Grid.Column>

        </Grid>
        </Card>
)
}

const styles = {
    card: {
         width:"80%",
        borderRadius: "38px",
        padding: 32,
    },
    icon: {
        color:'#59C4B0',
        textAlign:'center'
    },
    title:{
        color: '#4F6271',
        outline: 'none'
    }
}


export default HelpTile

